import { combineReducers } from "redux";
import authReducer from "./auth";
import messageReducer from "./message";

export default combineReducers({
  auth: authReducer,
  message: messageReducer,
});
